import { render, staticRenderFns } from "./editShipmentPackaging.vue?vue&type=template&id=38c12ca4&"
import script from "./editShipmentPackaging.vue?vue&type=script&lang=js&"
export * from "./editShipmentPackaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports